let currentBreakpoint = getBreakpointRange();
let currentGridWrapper = null;

// --- breakpoint helpers ---
function getBreakpointRange() {
  const width = window.innerWidth;
  if (width >= 1024) return 'large';
  if (width >= 769) return 'medium';
  return 'small';
}

function getDefaultClassForBreakpoint(breakpoint) {
  if (breakpoint === 'large') return 'col-4';
  if (breakpoint === 'medium') return 'col-3';
  return 'col-3';
}

// --- grid helpers ---
function getCurrentLayoutClass() {
  const item = document.querySelector('.collection-grid__wrapper .grid .grid__item');
  if (!item) return null;

  if (item.classList.contains('col-2')) return 'col-2';
  if (item.classList.contains('col-3')) return 'col-3';
  if (item.classList.contains('col-4')) return 'col-4';

  return null;
}

function setGridLayoutClass(className) {
  const items = document.querySelectorAll('.collection-grid__wrapper .grid .grid__item');
  items.forEach(item => {
    item.classList.remove('col-2', 'col-3', 'col-4');
    item.classList.add(className);
  });
}

function updateGridIconBasedOnClass(layoutClass) {
  const icons = document.querySelectorAll('.col-icon');
  icons.forEach(icon => icon.classList.remove('active'));
  document.querySelector(`.col-icon.${layoutClass}`)?.classList.add('active');
}

function handleResize() {
  const newBreakpoint = getBreakpointRange();
  if (newBreakpoint === currentBreakpoint) return;

  currentBreakpoint = newBreakpoint;

  const defaultClass = getDefaultClassForBreakpoint(currentBreakpoint);
  setGridLayoutClass(defaultClass);
  updateGridIconBasedOnClass(defaultClass);
}

function attachGridToggleListener() {
  const toggleButton = document.querySelector('.js-grid-toggle');
  if (!toggleButton) return;

  toggleButton.replaceWith(toggleButton.cloneNode(true));
  const newToggle = document.querySelector('.js-grid-toggle');

  newToggle.addEventListener('click', () => {
    const currentClass = getCurrentLayoutClass();
    const breakpoint = getBreakpointRange();
    const defaultClass = getDefaultClassForBreakpoint(breakpoint);

    let toggleClass = '';
    if (defaultClass === 'col-4') toggleClass = 'col-3';
    else if (defaultClass === 'col-3') toggleClass = 'col-2';
    else return;

    const newClass = currentClass === toggleClass ? defaultClass : toggleClass;

    setGridLayoutClass(newClass);
    updateGridIconBasedOnClass(newClass);
  });
}

function initGrid() {
  currentBreakpoint = getBreakpointRange();
  const defaultClass = getDefaultClassForBreakpoint(currentBreakpoint);
  setGridLayoutClass(defaultClass);
  updateGridIconBasedOnClass(defaultClass);
  attachGridToggleListener();
}

// --- initial run ---
document.addEventListener('DOMContentLoaded', () => {
  initGrid();
  window.addEventListener('resize', handleResize);

  // --- observe #CollectionAjaxContent ---
  const ajaxContainer = document.querySelector('#CollectionAjaxContent');
  if (ajaxContainer) {
    currentGridWrapper = document.querySelector('.collection-grid__wrapper');

    const observer = new MutationObserver(() => {
      const newGridWrapper = document.querySelector('.collection-grid__wrapper');
      // Only reinit if the grid wrapper has changed
      if (newGridWrapper && newGridWrapper !== currentGridWrapper) {
        currentGridWrapper = newGridWrapper;
        initGrid();
      }
    });

    observer.observe(ajaxContainer, { childList: true, subtree: true });
  }
});
